// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".change-password-modal .error-message {\n  color: maroon;\n}", "",{"version":3,"sources":["webpack://./src/app/pages/user/change.password/change.password.modal.scss"],"names":[],"mappings":"AACE;EACE,aAAA;AAAJ","sourcesContent":[".change-password-modal{\n  .error-message{\n    color: maroon;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
